function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";

  // --- Swiper progress reset logic ---
  // Find the swiper-component or card-product-slider inside the now visible tab
  const tabContent = document.getElementById(tabName);
  if (tabContent) {
    // Try swiper-component first
    let swiperEl = tabContent.querySelector('swiper-component');
    if (!swiperEl) {
      // Fallback to card-product-slider (legacy/custom element)
      swiperEl = tabContent.querySelector('card-product-slider');
    }
    if (!swiperEl) {
      // Fallback to direct .swiper class (if not using web components)
      swiperEl = tabContent.querySelector('.swiper');
    }
    if (swiperEl && swiperEl.swiper) {
      // Reset to first slide
      swiperEl.swiper.slideTo(0, 0);
      // Restart autoplay if available
      if (swiperEl.swiper.autoplay && typeof swiperEl.swiper.autoplay.start === 'function') {
        swiperEl.swiper.autoplay.start();
      }
    }
  }
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});
